import React from 'react';

import RichText from 'components/RichText/RichText';

import * as S from './SectionComponent.styles';

export interface SectionComponentProps {
  text: string;
  cta: {
    label: string;
    href: string;
  };
}

const defaultProps: Partial<SectionComponentProps> = {};

const SectionComponent: React.FunctionComponent<SectionComponentProps> = ({
  text,
  cta,
}) => {
  return (
    <S.SectionComponentWrapper>
      <RichText richText={text} />
      <S.Button label={cta.label} href={cta.href} />
    </S.SectionComponentWrapper>
  );
};

SectionComponent.defaultProps = defaultProps;

export default SectionComponent;
